// selectors.ts
import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'types';
import { AssetAllocatorState } from './types';
import { initialState } from '.';

const selectDomain = (state: RootState): AssetAllocatorState =>
  state.assetAllocator || initialState;

export const selectGoals = createSelector(
  [selectDomain],
  (state: AssetAllocatorState) => state.goals,
);

export const selectSelectedGoal = createSelector(
  [selectDomain],
  (state: AssetAllocatorState) => state.selectedGoal,
);

export const selectAllocations = createSelector(
  [selectDomain],
  (state: AssetAllocatorState) => state.allocations,
);

export const selectIsLoading = createSelector(
  [selectDomain],
  (state: AssetAllocatorState) => state.isLoading,
);

export const selectError = createSelector(
  [selectDomain],
  (state: AssetAllocatorState) => state.error,
);

export const selectAssets = createSelector(
  [selectDomain],
  (state: AssetAllocatorState) => state.assets.data,
);
